module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Interactions","completed":"Completed","upcoming":"Upcoming"},"fr":{"title":"Interactions","completed":"Complétées","upcoming":"À venir"}}')
  delete Component.options._Ctor
}
